import { Component, EventEmitter, Input, Output } from '@angular/core';
import {ANIMATION} from "../../../../constants/fields.constants";
import {INPUT_CONTAINER_CLASS} from "../../../../constants/data.constants";
import {DataService} from "../../../../../services/data.service";


@Component({
  selector: 'date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent {
  @Input() animation = ANIMATION;
  @Input() label = undefined;
  @Input() subLabel = undefined;
  @Input() active = false;

  @Input() toolTip = 'Enter filter Date';
  @Input() keyToolTip = 'Select key to use as Date Filter';
  @Input() labelToolTip = 'Filter By Date Range';
  @Input() endDateToolTip = 'Select End Date';

  @Input() icon = undefined;
  @Input() iconClass = '';
  @Input() keySuffixIcon = 'edit';
  @Input() order = 2;

  @Input() date = undefined;
  @Input() endDate = undefined;
  @Input() format = undefined;
  @Input() dateRange = false;
  @Input() startDateLabel = 'Start Date';
  @Input() endDateLabel = 'End Date';

  @Input() selectedKey = undefined;
  @Input() maxWidth = '170px';
  @Input() keys = [];

  @Output() labelClick = new EventEmitter<boolean>(true);
  @Output() selectedKeyChange = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<boolean>(true);

  @Output() change = new EventEmitter<any>();
  @Output() endDateChange = new EventEmitter<any>();
  @Output() startDateChange = new EventEmitter<any>();

  @Output() startEndDateChange = new EventEmitter<any>();

  inputContainerClass = INPUT_CONTAINER_CLASS;
  constructor(private ds:DataService){ }

  onDateChange($event: { value: any; }){
    let value = $event.value;

    if(this.format) value = this.ds.formatDate(value);
    this.dateRange ? this.startDateChange.emit(value) : this.change.emit(value);

    if(this.date && this.endDate) this.startEndDateChange.emit([
      this.ds.formatDate(this.date, this.format),
      this.ds.formatDate(this.endDate, this.format)
    ]);
  }

  onEndDateChange($event: { value: any; }){
    let value = $event.value;

    if(this.format) value = this.ds.formatDate(value);
    this.endDateChange.emit(value);

    if(this.date && this.endDate) this.startEndDateChange.emit([
      this.ds.formatDate(this.date, this.format),
      this.ds.formatDate(this.endDate, this.format)
    ]);
  }
}
